namespace $.$$ {

	export class $shm_projects_task_chat extends $.$shm_projects_task_chat {

		override chat_body() {
			return [ this.Process_view() ]
		}

		override Sessions_pick() {
			return null as any
		}

		override Goal_settings() {
			return null as any
		}

		override Chat_provider() {
			return null as any
		}

		run_busy() {
			const run = this.run() as $shm_projects_goal_run | null
			return run?.status === 'queued' || run?.status === 'running'
		}

		@ $mol_mem
		refresh( next?: number ) {
			return next ?? 0
		}

		override message_items() {
			this.refresh()
			const run = this.run() as $shm_projects_goal_run | null
			if( !run ) return []
			return Array.from( { length: run.iteration }, ( _, index )=> index + 1 )
				.flatMap( iteration => ( this as any ).iteration_messages( run, iteration ) )
		}

		override message_rows() {
			return [
				... super.message_rows(),
				...( this.run_busy() ? [ this.Reply_loader( 'task' ) ] : [] ),
			]
		}

		reply_waiting( thread = '' ) {
			return this.run_busy()
		}

		override reply_elapsed( thread: string ) {
			const run = this.run() as $shm_projects_goal_run | null
			if( !run || !this.run_busy() ) return ''
			const now = this.$.$mol_state_time.now( 1_000 )
			const started = run.iteration_started_at || run.started_at || now
			const elapsed = Math.max( 0, Math.floor( ( now - started ) / 1000 ) )
			const pad = ( value: number )=> String( value ).padStart( 2, '0' )
			const hours = Math.floor( elapsed / 3600 )
			const minutes = Math.floor( elapsed % 3600 / 60 )
			const seconds = elapsed % 60
			return hours ? `${ pad( hours ) }:${ pad( minutes ) }:${ pad( seconds ) }` : `${ pad( minutes ) }:${ pad( seconds ) }`
		}

	}

}
